const listeners = new Set();

export const subscribeVersionMismatch = (listener) => {
  listeners.add(listener);

  return () => listeners.delete(listener);
};

export const triggerVersionMismatch = (serverVersion) => {
  listeners.forEach((listener) => listener(serverVersion));
};
